module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
  with (locals || {}) {
    ; __append("<div class=\"feature-control flex flex-column\">\n    <div class=\"flex-none flex flex-row\">\n        <div class=\"flex-item\">\n            ")
    ; __append( UI.Template.render("UI/Widget/Forms/Control/Select/Control", {
                selected: source[ 0 ].value,
                attributes: {
                    name: 'selector'
                },
                source: source,
                value: 'value',
                title: 'title',
                showEmpty: false
            }) )
    ; __append("\n        </div>\n        <div class=\"flex-none flex flex-row\">\n            <button name=\"map-mode\" class=\"ctrl-psel-remove flex-item\" title=\"Режим редатирования\">\n                <div class=\"icon-21 icon-mode_edit\" style=\"color:#ffffff\"></div>\n            </button>\n            <img src=\"/images/preloader.gif\" name=\"feature_spinner\" class=\"feature_spinner\">\n            <button name=\"unbind\" class=\"ctrl-psel-unbind flex-item\" title=\"Отвязать\">\n                <div class=\"icon-21 icon-layers_clear\" style=\"color:#ffffff\"></div>\n            </button>\n        </div>\n    </div>\n\n    <div class=\"flex-item flex flex-column relative\">\n        <div name=\"feature-map\" class=\"feature-map flex-item\"></div>\n        ")
    ;  if (control.searchAttribute) { 
    ; __append("\n        <div name=\"search\" class=\"search\" title=\"Поиск по атрибуту ")
    ; __append(escapeFn( control.searchAttribute.name ))
    ; __append("\">\n			<span class=\"control-title\">Дата создания</span>\n			<div class=\"flex flex-row w100\">\n				<div class=\"flex flex-column\">\n					<input type=\"text\" name=\"from\" placeholder=\"С\">\n					<div class=\"from\" style=\"position: absolute;margin-top: 32px; z-index: 10;display: none;\"></div>\n				</div>\n				<div class=\"flex flex-column\">\n					<input type=\"text\" name=\"to\" placeholder=\"По\">\n					<div class=\"to\" style=\"position: absolute;margin-top: 32px; z-index: 10;display: none;\"></div>\n				</div>\n			</div>\n			<div class=\"progress-bar\" name=\"filter\">\n				<div class=\"indeterminate\"></div>\n			</div>\n            <input type=\"text\" name=\"query\" placeholder=\"Поиск по атрибуту ")
    ; __append(escapeFn( control.searchAttribute.name ))
    ; __append("\">\n            <div class=\"progress-bar\" name=\"search\">\n                <div class=\"indeterminate\"></div>\n            </div>\n            <div class=\"result\"></div>\n			<div name=\"feature-info\" class=\"feature-info flex-none flex flex-row\"></div>\n        </div>\n        ")
    ;  } 
    ; __append("\n    </div>\n\n    <div name=\"feature-info\" class=\"feature-info flex-none flex flex-row\"></div>\n</div>\n")
  }
  return __output.join("");

}